import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import Loading from "../../../views/Loading";
import ReactTable from "react-table-6";
import { sociedades } from "../../../variables/constantes";
import "react-table-6/react-table.css";
import "./style.css";
import Swal from "sweetalert2";
import { dominio, dominioMOSA, dominioTRANSFLESA } from "../../../routes_backend/routes.jsx";

/* ========= Componente tarjeta (fuera de la clase) ========= */
function CardSolicitud({
  row,
  index,
  styles,
  data_status,
  formatDate,
  abrirModalVistaPrevia,
  abrirModalAdjuntos,
  get_status,
  getComments,
  onAutorizar,
  statusAutorizadores = [],
  mostrarAutorizadores = false,
  sociedadKey = "MACIZO",
  onToggleAutorizadores = () => {},
}) {
  const formatStatusDate = (dateValue) => {
    if (!dateValue || dateValue === "NULL") return "Pendiente";
    if (typeof dateValue === "string" && dateValue.includes("/")) return dateValue;
    return formatDate(dateValue);
  };

  const formatStatusHour = (hourValue) => {
    if (!hourValue || hourValue === "NULL") return "Pendiente";
    const textHour = String(hourValue).padStart(4, "0");
    return `${textHour.slice(0, -2)}:${textHour.slice(-2)}`;
  };

const formatStatusFecha = (dateValue) => {
  if (!dateValue || dateValue === "NULL") return "Pendiente";

  const value = String(dateValue).trim();

  // Si ya viene como dd/mm/yyyy
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return value;
  }

  // Si viene como yyyy-mm-dd o yyyy-mm-dd HH:mm:ss
  const isoDate = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) {
    const [, year, month, day] = isoDate;
    return `${day}/${month}/${year}`;
  }

  // Si viene como: Wed, 10 Jun 2026 00:00:00 GMT
  // Usamos UTC para NO bajarlo a 09/06/2026 en Guatemala
  const date = new Date(value);

  if (!isNaN(date.getTime())) {
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  return value;
};


  return (
    <div style={styles.card}>
      <div style={styles.headerGrid}>
        <div style={styles.pill}>
          <span>solicitud</span>
          <button
            style={{ ...styles.pillBtn, ...styles.pillBlue }}
            onClick={() => abrirModalVistaPrevia(row.DocEntry, row.DocType)}
          >
            {row.DocEntry}
          </button>
        </div>
        <div style={styles.pill}>
          <span>Adjunto</span>
          <button
            style={{
              ...styles.pillBtn,
              ...(parseInt(row.Adjunto) === 0 ? styles.pillGray : styles.pillRed),
            }}
            disabled={parseInt(row.Adjunto) === 0}
            onClick={() => abrirModalAdjuntos(row.DocEntry, row.Adjunto)}
          >
            Ver
          </button>
        </div>
        <div style={styles.pill}>
          <span>Documento</span>
          <div style={styles.pillStatic}>{row.DocEntry}</div>
        </div>
      </div>



      <div style={styles.bodyGrid}>
        <div>
          <div style={styles.label}>Solicitante</div>
          <div style={styles.value}>{row.U_NAME}</div>
        </div>
        <div>
          <div style={styles.label}>Fecha</div>
          <div style={styles.value}>{row.DocDate ? formatStatusFecha(row.DocDate) : ""}</div>
        </div>
        <div>
          <div style={styles.label}>Hora</div>
          <div style={styles.value}>{row.Hora || formatStatusHour(row.CreateTime)}</div>
        </div>
      </div>

      <div style={styles.actions}>
        <div>
          <select
            value={row.estatus}
            name="id_status"
            id={`id_status_${row.DocEntry}`}
            className="form-control"
            onChange={(e) => get_status(index, e.target.value)}
          >
            {data_status.map((res) => (
              <option key={res.text} value={res.text}>
                {res.id}
              </option>
            ))}
          </select>
        </div>

        <div>
          <textarea
            className="comments"
            maxLength={75}
            placeholder="Comentarios"
            value={row.Comments}
            onChange={(e) => getComments(index, e.target.value)}
            style={{ width: "100%", height: 34, resize: "vertical" }}
          />
        </div>

        <div style={{ textAlign: "right" }}>
          <button style={styles.btnPrimary} onClick={() => onAutorizar(row)}>
            Autorizar
          </button>
        </div>
      </div>

      <div style={styles.autorizadoresButtonRow}>
        <button
          type="button"
          style={styles.btnAutorizadores}
          onClick={() => onToggleAutorizadores(row.DocEntry, sociedadKey)}
        >
          {mostrarAutorizadores ? "Ocultar autorizadores" : "Ver autorizadores"}
        </button>
      </div>

      {mostrarAutorizadores && (
        <div style={styles.statusBox}>
          <div style={styles.statusTitle}>Estado de autorizadores</div>
          {Array.isArray(statusAutorizadores) && statusAutorizadores.length > 0 ? (
            statusAutorizadores.map((item, statusIndex) => (
              <div key={`${row.DocEntry}_status_${statusIndex}`} style={styles.statusItem}>
                <div style={styles.statusGrid}>
                  <div>
                    <div style={styles.label}>Autorizador</div>
                    <div style={styles.value}>{item.Autorizador || ""}</div>
                  </div>
                  <div>
                    <div style={styles.label}>Fecha Actualización</div>
                    <div style={styles.value}>{formatStatusDate(item.Fecha_Actualizacion)}</div>
                  </div>
                  <div>
                    <div style={styles.label}>Días</div>
                    <div style={styles.value}>{item.Dias_Para_Autorizacion ?? 0}</div>
                  </div>
                  <div>
                    <div style={styles.label}>Estado</div>
                    <div style={styles.value}>{item.EstadoD || "Pendiente"}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div style={styles.statusEmpty}>No hay autorizadores para este documento</div>
          )}
        </div>
      )}
    </div>
  );
}

/* ============================ Clase ============================ */
class Autorizaciones_compras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,

      listAutorizacionesMACIZO: [],
      listAutorizacionesMOSA: [],
      listAutorizacionesTRANSFLESA: [],
      listStatusAutorizadoresMACIZO: [],
      listStatusAutorizadoresMOSA: [],
      autorizadoresVisibles: {},

      comments: "",
      status: 1,

      sociedad: sociedades,
      is_sociedad: "SBO_MACIZO",

      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",

      usrWisap: "",
      userWisapId: "",
      db_sociedad: "",
      url_autorizaciones: "",
      name_sociedad: "",
      id_sociedad: "",

      isModalOpenVistaPrevia: false,
      isModalOpenAdjuntos: false,
      listAutorizacionesVistaPrevia: [],

      // Adjuntos
      adjuntoBase64: null,
      pdfUrl: null,
    };

    this.onChange = this.onChange.bind(this);

    // Adjuntos
    this.abrirModalAdjuntos = this.abrirModalAdjuntos.bind(this);
    this.abrirModalAdjuntosMOSA = this.abrirModalAdjuntosMOSA.bind(this);
    this.abrirModalAdjuntosTRANSFLESA = this.abrirModalAdjuntosTRANSFLESA.bind(this);

    // Vista previa
    this.abrirModalVistaPrevia = this.abrirModalVistaPrevia.bind(this);
    this.abrirModalVistaPreviaMOSA = this.abrirModalVistaPreviaMOSA.bind(this);
    this.abrirModalVistaPreviaTRANSFLESA = this.abrirModalVistaPreviaTRANSFLESA.bind(this);

    this.cerrarModalVistaPrevia = this.cerrarModalVistaPrevia.bind(this);
    this.cerrarModalAdjuntos = this.cerrarModalAdjuntos.bind(this);
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCloseEnable = () => {
    this.setState({ showModalconfirm: false });
  };

  // ✅ Convierte Base64 a Blob (PDF) para vista previa estable (sin data:URI gigante)
  base64ToBlob = (base64, contentType = "application/pdf") => {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    const sliceSize = 1024;

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  };

  // ✅ Descarga usando Blob (más estable que data:URL)
  descargarAdjunto = () => {
    const { adjuntoBase64 } = this.state;
    if (!adjuntoBase64) return;

    const blob = this.base64ToBlob(adjuntoBase64, "application/pdf");
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "adjunto.pdf";
    link.click();

    URL.revokeObjectURL(url);
  };

  componentWillMount(user, Iduser, sociedad) {
    let token = localStorage.getItem("token");
    if (token !== null) {
      let token_Data = JSON.parse(token);
      token_Data.forEach((element) => {
        user = element.USER_CODE;
        Iduser = element.U_UserId;
        sociedad = element.db;
      });
    }
    this.datosBDMACIZO();
  }

  datosBDMACIZO = () => {
    this.get_list_autorizacionesMACIZO();
    this.get_list_autorizacionesMOSA();
    this.get_list_autorizacionesTRANSFLESA();
    this.get_StatusAutorizadoresMACIZO();
    this.get_StatusAutorizadoresMOSA();
  };

  // ------- helpers -------
  normalizeRows = (arr) =>
    Array.isArray(arr)
      ? arr.map((it) => ({
          ...it,
          estatus: it.estatus || "ardPending",
          Comments: typeof it.Comments === "string" ? it.Comments : "",
        }))
      : [];

  normalizeStatusAutorizadores = (arr) =>
    Array.isArray(arr)
      ? arr.map((it) => ({
          ...it,
          Comments: typeof it.Comments === "string" ? it.Comments : "",
        }))
      : [];

  toggleAutorizadores = (DocEntry, sociedadKey = "MACIZO") => {
    const key = `${sociedadKey}_${DocEntry}`;

    this.setState((prev) => ({
      autorizadoresVisibles: {
        ...prev.autorizadoresVisibles,
        [key]: !prev.autorizadoresVisibles[key],
      },
    }));

    if (sociedadKey === "MOSA") {
      this.get_StatusAutorizadoresMOSA();
    } else {
      this.get_StatusAutorizadoresMACIZO();
    }
  };

  getStatusAutorizadoresPorDocumento = (DocEntry, sociedadKey = "MACIZO") => {
    const { listStatusAutorizadoresMACIZO, listStatusAutorizadoresMOSA } = this.state;
    const list = sociedadKey === "MOSA" ? listStatusAutorizadoresMOSA : listStatusAutorizadoresMACIZO;

    return Array.isArray(list)
      ? list.filter(
          (item) => String(item.DocEntry) === String(DocEntry) || String(item.DraftEntry) === String(DocEntry)
        )
      : [];
  };

  get_StatusAutorizadoresMACIZO = () => {
    fetch(`${dominio}/get_StatusAutorizadores`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(text || `Error ${res.status}`);
        }
        const payload = await res.json();
        const rows = Array.isArray(payload) ? payload : Array.isArray(payload.data) ? payload.data : [];
        console.log("Status autorizadores MACIZO:", rows);
        this.setState({ listStatusAutorizadoresMACIZO: this.normalizeStatusAutorizadores(rows) });
      })
      .catch((error) => {
        console.log("Error obteniendo status de autorizadores MACIZO:", error);
        this.setState({ listStatusAutorizadoresMACIZO: [] });
      });
  };

  get_StatusAutorizadoresMOSA = () => {
    fetch(`${dominio}/get_StatusAutorizadoresMOSA`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(text || `Error ${res.status}`);
        }
        const payload = await res.json();
        const rows = Array.isArray(payload) ? payload : Array.isArray(payload.data) ? payload.data : [];
        console.log("Status autorizadores MOSA:", rows);
        this.setState({ listStatusAutorizadoresMOSA: this.normalizeStatusAutorizadores(rows) });
      })
      .catch((error) => {
        console.log("Error obteniendo status de autorizadores MOSA:", error);
        this.setState({ listStatusAutorizadoresMOSA: [] });
      });
  };

  // ======================= LISTAS =======================
  get_list_autorizacionesMACIZO = () => {
    const { is_sociedad } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";

    const tokenRaw = localStorage.getItem("token");
    let token_Data = null;
    try {
      token_Data = tokenRaw ? JSON.parse(tokenRaw) : null;
    } catch (e) {
      token_Data = null;
    }

    const dulRaw = localStorage.getItem("DATA_USUARIOS_LOGIN");
    let dataUsuariosLogin = null;
    try {
      dataUsuariosLogin = dulRaw ? JSON.parse(dulRaw) : null;
    } catch (e) {
      dataUsuariosLogin = null;
    }

    if (Array.isArray(token_Data) && token_Data.length > 0) {
      const last = token_Data[token_Data.length - 1];
      username = last.usuarioSAP || "";
      password = last.contraseñaSAP || "";
      codigoUser = last.U_UserId || "";
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({
      message: "",
      isLoading: true,
      listAutorizacionesMACIZO: [],
      comments: "",
      status: 1,
      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",
    });

    fetch(`${dominio}/get_ListRequisicionesBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username,
        password,
        codigoUser: dataUsuariosLogin?.user_id,
        is_sociedad,
      }),
    })
      .then(async (res) => {
        if (res.status === 404) {
          const errorData = await res.json();
          this.setState({
            isLoading: false,
            message: errorData.error || "No hay autorizaciones pendientes con este usuario",
          });
          return;
        }
        const data = await res.json();
        this.setState({
          listAutorizacionesMACIZO: this.normalizeRows(data),
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({ isLoading: false, message: "No hay autorizaciones pendientes con este usuario" });
      });
  };

  get_list_autorizacionesMOSA = () => {
    const { is_sociedad } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";

    const tokenRaw = localStorage.getItem("token");
    let token_Data = null;
    try {
      token_Data = tokenRaw ? JSON.parse(tokenRaw) : null;
    } catch (e) {
      token_Data = null;
    }

    const dulRaw = localStorage.getItem("DATA_USUARIOS_LOGIN");
    let dataUsuariosLogin = null;
    try {
      dataUsuariosLogin = dulRaw ? JSON.parse(dulRaw) : null;
    } catch (e) {
      dataUsuariosLogin = null;
    }

    if (Array.isArray(token_Data) && token_Data.length > 0) {
      const last = token_Data[token_Data.length - 1];
      username = last.usuarioSAP || "";
      password = last.contraseñaSAP || "";
      codigoUser = last.U_UserId || "";
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({
      message: "",
      isLoading: true,
      listAutorizacionesMOSA: [],
      comments: "",
      status: 1,
      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",
    });

    const adjustedUsername =
      username === "gerentegeneral" || username === "GERENTEGENERAL"
        ? "GERENCIAGENERAL"
        : username;

    fetch(`${dominioMOSA}/get_ListRequisicionesBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adjustedUsername: adjustedUsername,
        password: password,
        codigoUser: dataUsuariosLogin?.user_idMOSA,
        is_sociedad: is_sociedad,
      }),
    })
      .then(async (res) => {
        if (res.status === 404) {
          const errorData = await res.json().catch(() => ({}));
          this.setState({
            isLoading: false,
            message: errorData?.error || "No hay autorizaciones pendientes con este usuario",
          });
          return;
        }

        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(text || `Error ${res.status}`);
        }

        const dataMOSA = await res.json();
        this.setState({
          listAutorizacionesMOSA: this.normalizeRows(dataMOSA),
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          message: "No hay autorizaciones pendientes con este usuario",
        });
      });
  };

  get_list_autorizacionesTRANSFLESA = () => {
    const { is_sociedad } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";

    const tokenRaw = localStorage.getItem("token");
    let token_Data = null;
    try {
      token_Data = tokenRaw ? JSON.parse(tokenRaw) : null;
    } catch (e) {
      token_Data = null;
    }

    const dulRaw = localStorage.getItem("DATA_USUARIOS_LOGIN");
    let dataUsuariosLogin = null;
    try {
      dataUsuariosLogin = dulRaw ? JSON.parse(dulRaw) : null;
    } catch (e) {
      dataUsuariosLogin = null;
    }

    if (Array.isArray(token_Data) && token_Data.length > 0) {
      const last = token_Data[token_Data.length - 1];
      username = last.usuarioSAP || "";
      password = last.contraseñaSAP || "";
      codigoUser = last.U_UserId || "";
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({
      message: "",
      isLoading: true,
      listAutorizacionesTRANSFLESA: [],
      comments: "",
      status: 1,
      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",
    });

    fetch(`${dominioTRANSFLESA}/get_ListRequisicionesBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username,
        password,
        codigoUser: dataUsuariosLogin?.user_idTRANSFLESA,
        is_sociedad,
      }),
    })
      .then(async (res) => {
        if (res.status === 404) {
          const errorData = await res.json();
          this.setState({
            isLoading: false,
            message: errorData.error || "No hay autorizaciones pendientes con este usuario",
          });
          return;
        }
        const dataTRANSFLESA = await res.json();
        this.setState({
          listAutorizacionesTRANSFLESA: this.normalizeRows(dataTRANSFLESA),
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({ isLoading: false, message: "No hay autorizaciones pendientes con este usuario" });
      });
  };

  // ======================= AUTORIZAR =======================
  autorizarMACIZO = async (data) => {
    this.setState({ message: "", isLoading: true, messageConfirm: "" });

    const commentario = data.Comments || "";
    const status = data.estatus || "";
    if (status === "") {
      this.setState({ isLoading: false, message: "Estatus no proporcionado." });
      return;
    }

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (!token_Data) {
      this.props.history.push("");
      return;
    }

    const { WddCode, DocEntry } = data;
    let username = "";
    let password = "";
    token_Data.forEach((element) => {
      username = element.usuarioSAP;
      password = element.contraseñaSAP;
    });

    try {
      const response = await fetch(`${dominio}/updateAutorizacionesBETA`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ WddCode, commentario, status, username, password }),
      });

      const resp = await response.json();
      if (!resp.success) throw new Error(resp[0]?.message || "Error desconocido al actualizar autorizaciones");

      Swal.fire({ icon: "success", title: "Éxito", text: "Registro actualizado correctamente" });

      if (status === "ardApproved") {
        await fetch(`${dominio}/ConvertDraftToDocumentBETA`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password, DocEntry }),
        });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error en la solicitud", text: error.message || "Mensaje de error no disponible" });
    } finally {
      this.datosBDMACIZO();
      this.setState({ isLoading: false });
    }
  };

  autorizarMOSA = async (data) => {
    this.setState({ message: "", isLoading: true, messageConfirm: "" });

    const commentario = data.Comments || "";
    const status = data.estatus || "";
    if (status === "") {
      this.setState({ isLoading: false, message: "Estatus no proporcionado." });
      return;
    }

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (!token_Data) {
      this.props.history.push("");
      return;
    }

    const { WddCode, DocEntry } = data;
    let username = "";
    let password = "";
    token_Data.forEach((element) => {
      username = element.usuarioSAP;
      password = element.contraseñaSAP;
    });

    const adjustedUsername =
      username === "gerentegeneral" || username === "GERENTEGENERAL" ? "GERENCIAGENERAL" : username;

    try {
      const response = await fetch(`${dominioMOSA}/updateAutorizacionesBETA`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ WddCode, commentario, status, adjustedUsername, password }),
      });

      const dataMOSA = await response.json();
      if (!dataMOSA.success) throw new Error(dataMOSA[0]?.message || "Error desconocido al actualizar autorizaciones");

      Swal.fire({ icon: "success", title: "Éxito", text: "Registro actualizado correctamente" });

      if (status === "ardApproved") {
        await fetch(`${dominioMOSA}/ConvertDraftToDocumentBETA`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ adjustedUsername, password, DocEntry }),
        });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error en la solicitud", text: error.message || "Mensaje de error no disponible" });
    } finally {
      this.datosBDMACIZO();
      this.setState({ isLoading: false });
    }
  };

  autorizarTRANSFLESA = async (data) => {
    this.setState({ message: "", isLoading: true, messageConfirm: "" });

    const commentario = data.Comments || "";
    const status = data.estatus || "";
    if (status === "") {
      this.setState({ isLoading: false, message: "Estatus no proporcionado." });
      return;
    }

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (!token_Data) {
      this.props.history.push("");
      return;
    }

    const { WddCode, DocEntry } = data;
    let username = "";
    let password = "";
    token_Data.forEach((element) => {
      username = element.usuarioSAP;
      password = element.contraseñaSAP;
    });

    try {
      const response = await fetch(`${dominioTRANSFLESA}/updateAutorizacionesBETA`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ WddCode, commentario, status, username, password }),
      });

      const dataTRANSFLESA = await response.json();
      if (!dataTRANSFLESA.success)
        throw new Error(dataTRANSFLESA[0]?.message || "Error desconocido al actualizar autorizaciones");

      Swal.fire({ icon: "success", title: "Éxito", text: "Registro actualizado correctamente" });

      if (status === "ardApproved") {
        await fetch(`${dominioTRANSFLESA}/ConvertDraftToDocumentBETA`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password, DocEntry }),
        });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error en la solicitud", text: error.message || "Mensaje de error no disponible" });
    } finally {
      this.datosBDMACIZO();
      this.setState({ isLoading: false });
    }
  };

  // ======================= ADJUNTOS (✅ SOLO AQUÍ CAMBIO) =======================
  // ✅ MACIZO
  abrirModalAdjuntos = async (DocEntry) => {
    const { is_sociedad } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({ message: "", isLoading: true });

    fetch(`${dominio}/get_ListRequisicionesAdjuntosBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, codigoUser, is_sociedad, DocEntry }),
    })
      .then(async (res) => {
        let data = await res.json();
        const adjuntoBase64 = data.length > 0 ? data[0].doc : null;

        // Limpia URL anterior si existía
        if (this.state.pdfUrl) {
          URL.revokeObjectURL(this.state.pdfUrl);
        }

        let pdfUrl = null;
        if (adjuntoBase64) {
          try {
            const blob = this.base64ToBlob(adjuntoBase64, "application/pdf");
            pdfUrl = URL.createObjectURL(blob);
          } catch (e) {
            console.log("Error creando Blob URL:", e);
          }
        }

        this.setState({ isLoading: false, isModalOpenAdjuntos: true, adjuntoBase64, pdfUrl });
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  // ✅ MOSA
  abrirModalAdjuntosMOSA = async (DocEntry) => {
    let is_sociedad = "SBO_MOSA";

    let username = "";
    let password = "";
    let codigoUser = "";
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({ message: "", isLoading: true });

    const adjustedUsername =
      username === "gerentegeneral" || username === "GERENTEGENERAL" ? "GERENCIAGENERAL" : username;
    const adjustedCodigoUser =
      username === "gerentegeneral" || username === "GERENTEGENERAL" ? "41" : codigoUser;

    fetch(`${dominioMOSA}/get_ListRequisicionesAdjuntosBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adjustedUsername, password, adjustedCodigoUser, is_sociedad, DocEntry }),
    })
      .then(async (res) => {
        let data = await res.json();
        const adjuntoBase64 = data.length > 0 ? data[0].doc : null;

        // Limpia URL anterior si existía
        if (this.state.pdfUrl) {
          URL.revokeObjectURL(this.state.pdfUrl);
        }

        let pdfUrl = null;
        if (adjuntoBase64) {
          try {
            const blob = this.base64ToBlob(adjuntoBase64, "application/pdf");
            pdfUrl = URL.createObjectURL(blob);
          } catch (e) {
            console.log("Error creando Blob URL:", e);
          }
        }

        this.setState({ isLoading: false, isModalOpenAdjuntos: true, adjuntoBase64, pdfUrl });
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  // ✅ TRANSFLESA
  abrirModalAdjuntosTRANSFLESA = async (DocEntry) => {
    const { is_sociedad } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    } else {
      this.props.history.push("");
      return;
    }

    this.setState({ message: "", isLoading: true });

    fetch(`${dominioTRANSFLESA}/get_ListRequisicionesAdjuntosBETA`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, codigoUser, is_sociedad, DocEntry }),
    })
      .then(async (res) => {
        let data = await res.json();
        const adjuntoBase64 = data.length > 0 ? data[0].doc : null;

        // Limpia URL anterior si existía
        if (this.state.pdfUrl) {
          URL.revokeObjectURL(this.state.pdfUrl);
        }

        let pdfUrl = null;
        if (adjuntoBase64) {
          try {
            const blob = this.base64ToBlob(adjuntoBase64, "application/pdf");
            pdfUrl = URL.createObjectURL(blob);
          } catch (e) {
            console.log("Error creando Blob URL:", e);
          }
        }

        this.setState({ isLoading: false, isModalOpenAdjuntos: true, adjuntoBase64, pdfUrl });
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  // ======================= VISTA PREVIA (SIN CAMBIOS) =======================
  abrirModalVistaPrevia(solicitud) {
    const { is_sociedad } = this.state;

    if (is_sociedad === "SBO_MACIZO") {
      let username = "";
      let password = "";
      let token = localStorage.getItem("token");
      let token_Data = JSON.parse(token);

      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      } else {
        this.props.history.push("");
        return;
      }

      this.setState({ message: "", isLoading: true });

      fetch(`${dominio}/get_ListRequisicionesVistaPreviaBETA`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, solicitud }),
      })
        .then(async (res) => {
          let data = await res.json();
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
            isModalOpenVistaPrevia: true,
          });
        })
        .catch(() =>
          this.setState({
            isLoading: false,
            message: "No hay autorizaciones pendientes con este usuario",
          })
        );
    }
  }

  abrirModalVistaPreviaMOSA(solicitud) {
    const { is_sociedad } = this.state;

    if (is_sociedad === "SBO_MACIZO") {
      let username = "";
      let password = "";
      let token = localStorage.getItem("token");
      let token_Data = JSON.parse(token);

      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      } else {
        this.props.history.push("");
        return;
      }

      const adjustedUsername =
        username === "gerentegeneral" || username === "GERENTEGENERAL"
          ? "GERENCIAGENERAL"
          : username;

      this.setState({ message: "", isLoading: true });

      fetch(`${dominioMOSA}/get_ListRequisicionesVistaPreviaBETA`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: adjustedUsername, password, solicitud }),
      })
        .then(async (res) => {
          const data = await res.json();
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
            isModalOpenVistaPrevia: true,
          });
        })
        .catch(() =>
          this.setState({
            isLoading: false,
            message: "No hay autorizaciones pendientes con este usuario",
          })
        );
    }
  }

  abrirModalVistaPreviaTRANSFLESA(solicitud) {
    const { is_sociedad } = this.state;

    if (is_sociedad === "SBO_MACIZO") {
      let username = "";
      let password = "";
      let token = localStorage.getItem("token");
      let token_Data = JSON.parse(token);

      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
        });
      } else {
        this.props.history.push("");
        return;
      }

      this.setState({ message: "", isLoading: true });

      fetch(`${dominioTRANSFLESA}/get_ListRequisicionesVistaPreviaBETA`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, solicitud }),
      })
        .then(async (res) => {
          const data = await res.json();
          this.setState({
            listAutorizacionesVistaPrevia: data,
            isLoading: false,
            isModalOpenVistaPrevia: true,
          });
        })
        .catch(() =>
          this.setState({
            isLoading: false,
            message: "No hay autorizaciones pendientes con este usuario",
          })
        );
    }
  }

  cerrarModalVistaPrevia() {
    this.setState({ isModalOpenVistaPrevia: false });
  }

  // ✅ Cierra modal adjuntos y libera memoria del objectURL
  cerrarModalAdjuntos() {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl);
    }
    this.setState({ isModalOpenAdjuntos: false, adjuntoBase64: null, pdfUrl: null });
  }

  // ======================= Handlers por lista =======================
  getComments = (index, Comments) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesMACIZO];
      if (list[index]) list[index] = { ...list[index], Comments };
      return { listAutorizacionesMACIZO: list };
    });
  };
  get_status = (index, estatus) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesMACIZO];
      if (list[index]) list[index] = { ...list[index], estatus };
      return { listAutorizacionesMACIZO: list };
    });
  };

  getCommentsMOSA = (index, Comments) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesMOSA];
      if (list[index]) list[index] = { ...list[index], Comments };
      return { listAutorizacionesMOSA: list };
    });
  };
  get_statusMOSA = (index, estatus) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesMOSA];
      if (list[index]) list[index] = { ...list[index], estatus };
      return { listAutorizacionesMOSA: list };
    });
  };

  getCommentsTRANSFLESA = (index, Comments) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesTRANSFLESA];
      if (list[index]) list[index] = { ...list[index], Comments };
      return { listAutorizacionesTRANSFLESA: list };
    });
  };
  get_statusTRANSFLESA = (index, estatus) => {
    this.setState((prev) => {
      const list = [...prev.listAutorizacionesTRANSFLESA];
      if (list[index]) list[index] = { ...list[index], estatus };
      return { listAutorizacionesTRANSFLESA: list };
    });
  };

  // ======================= Render =======================
  render() {
    const {
      listAutorizacionesVistaPrevia,
      isLoading,
      message,
      isModalOpenVistaPrevia,
      isModalOpenAdjuntos,
      pdfUrl,
    } = this.state;

    const formatDate = (dateValue) => {
      if (!dateValue || dateValue === "NULL") return "";

      if (typeof dateValue === "string") {
        const value = dateValue.trim();

        // Si el backend ya envia dd/mm/yyyy, se muestra directo.
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          return value;
        }

        // Evita usar new Date("yyyy-mm-dd"), porque JavaScript lo interpreta como UTC
        // y en Guatemala puede restar un dia.
        const isoDate = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoDate) {
          const [, year, month, day] = isoDate;
          return `${day}/${month}/${year}`;
        }

        // Formato compacto por si algun endpoint devuelve yyyymmdd.
        const compactDate = value.match(/^(\d{4})(\d{2})(\d{2})$/);
        if (compactDate) {
          const [, year, month, day] = compactDate;
          return `${day}/${month}/${year}`;
        }
      }

      // Para objetos Date reales u otros formatos, usar fecha local.
      const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
      if (isNaN(date.getTime())) return "";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    };

    const data_status = [
      { id: "Pendiente", text: "ardPending" },
      { id: "Autorizado", text: "ardApproved" },
      { id: "Rechazado", text: "ardNotApproved" },
    ];

    const styles = {
      layout: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14 },
      column: { background: "#eef1f7", borderRadius: 12, padding: 10, minHeight: 100 },
      columnHeader: { textAlign: "center", fontWeight: 800, letterSpacing: 1, marginBottom: 8 },
      empty: { textAlign: "center", padding: 16, opacity: 0.7 },
      card: { background: "#fff", borderRadius: 12, boxShadow: "0 1px 5px rgba(0,0,0,.07)", padding: 12, marginBottom: 10 },
      headerGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 8 },
      pill: { display: "grid", gridTemplateRows: "auto auto", gap: 4 },
      pillBtn: { border: "none", borderRadius: 10, padding: "6px 10px", cursor: "pointer", textAlign: "center" },
      pillBlue: { background: "#e7f3ff" },
      pillRed: { background: "#ffe8e8" },
      pillGray: { background: "#f0f0f0", cursor: "not-allowed" },
      pillStatic: { background: "#f6f7fb", borderRadius: 10, padding: "6px 10px", textAlign: "center" },
      bodyGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, margin: "8px 0" },
      label: { fontSize: 11, opacity: 0.6 },
      value: { fontSize: 13 },
      actions: { display: "grid", gridTemplateColumns: "150px 1fr 110px", gap: 8, alignItems: "center", marginTop: 6 },
      btnPrimary: { padding: "8px 12px", borderRadius: 10, border: "none", background: "#2e6da4", color: "#fff", cursor: "pointer" },
      autorizadoresButtonRow: { marginTop: 8, textAlign: "center" },
      btnAutorizadores: { padding: "7px 12px", borderRadius: 10, border: "none", background: "#5bc0de", color: "#fff", cursor: "pointer", fontWeight: 700, width: "100%" },
      statusBox: { marginTop: 10, paddingTop: 8, borderTop: "1px solid #edf0f5", textAlign: "left" },
      statusTitle: { fontSize: 12, fontWeight: 800, marginBottom: 6, textAlign: "center" },
      statusItem: { background: "#f8f9fc", borderRadius: 10, padding: 8, marginTop: 6 },
      statusGrid: { display: "grid", gridTemplateColumns: "1.4fr 1.2fr .6fr 1fr", gap: 6 },
      statusComments: { marginTop: 6, fontSize: 12, whiteSpace: "normal", wordBreak: "break-word" },
      statusEmpty: { background: "#fff8e1", borderRadius: 10, padding: 8, marginTop: 6, fontSize: 12, textAlign: "center" },
    };

    return (
      <div className="content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              {/* ---------- Modal Vista Previa ---------- */}
              <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenVistaPrevia ? "block" : "none" }}>
                <div className=" modal-dialog-custom-width" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Vista Previa</h5>
                      <button type="button" className="close" aria-label="Close" onClick={this.cerrarModalVistaPrevia}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
                      {Array.isArray(listAutorizacionesVistaPrevia) && listAutorizacionesVistaPrevia.length > 0 && (
                        <>
                          <div>
                            <strong>Solicitante:</strong> {listAutorizacionesVistaPrevia[0].U_NAME} &nbsp;&nbsp;&nbsp;
                            <strong># Documento:</strong> {listAutorizacionesVistaPrevia[0].DraftEntry}
                          </div>

                          <table>
                            <thead>
                              <tr>
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Almacen</th>
                                <th>Cantidad</th>
                                <th>Stock</th>
                                <th>Comprometido</th>
                                <th>Precio</th>
                                <th>Total Linea</th>
                              </tr>
                            </thead>
                            <tbody>
                              {listAutorizacionesVistaPrevia.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.ItemCode || "Servicio"}</td>
                                  <td>{item.Dscription || "Sin descripción"}</td>
                                  <td>{item.WhsCode || "N/A"}</td>
                                  <td>{item.Quantity || 0}</td>
                                  <td>{item.OnHand || 0}</td>
                                  <td>{item.IsCommited || "N/A"}</td>
                                  <td>
                                    {item.Price
                                      ? parseFloat(item.Price).toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                      : "0.00"}
                                  </td>
                                  <td>
                                    {!item.ItemCode
                                      ? parseFloat(item.Price).toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                      : (parseFloat(item.Price) * parseFloat(item.Quantity)).toLocaleString("es-GT", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div className="info-section">
                            <div className="comments">
                              <strong>Comentario:</strong> &nbsp; {listAutorizacionesVistaPrevia[0].Comments}
                            </div>
                            <div className="total">
                              <strong>Total:</strong>{" "}
                              {listAutorizacionesVistaPrevia
                                .reduce((sum, item) => {
                                  const quantity = item.Quantity || 0;
                                  const price = parseFloat(item.Price || 0);
                                  return sum + (quantity > 0 ? price * quantity : price);
                                }, 0)
                                .toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              <br />
                            </div>
                          </div>

                          <div className="create-date">
                            <strong>Fecha Creacion:</strong>{" "}
                            {formatDate(listAutorizacionesVistaPrevia[0].DocDate || listAutorizacionesVistaPrevia[0].CreateDate)}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={this.cerrarModalVistaPrevia}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* ---------- Modal Adjuntos (✅ CAMBIADO: Blob URL SIEMPRE) ---------- */}
              <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenAdjuntos ? "block" : "none" }}>
                <div className="modal-dialog-custom-width" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Vista Previa</h5>
                      <button type="button" className="close" aria-label="Close" onClick={this.cerrarModalAdjuntos}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div
                      className="modal-body"
                      style={{
                        height: "700px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pdfUrl ? (
                        <iframe
                          src={pdfUrl}
                          style={{ width: "100%", height: "100%" }}
                          frameBorder="0"
                          title="Vista previa PDF"
                        />
                      ) : (
                        <p>No hay adjunto para mostrar</p>
                      )}
                    </div>

                    <div className="modal-footer">
                      <button type="button" className="btn btn-primary" onClick={this.descargarAdjunto}>
                        Descargar
                      </button>
                      <button type="button" className="btn btn-secondary" onClick={this.cerrarModalAdjuntos}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* ---------- Contenido principal ---------- */}
              <Card
                title="AUTORIZACIONES"
                category="AUTORIZACIONES"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="row">
                      <div className="col-sm-12">
                        <br />
                      </div>
                      <br />
                      &nbsp;
                      <br />

                      {/* ====== LAYOUT 3 COLUMNAS ====== */}
                      <div style={styles.layout}>
                        {/* MACIZO */}
                        <div style={styles.column}>
                          <div style={styles.columnHeader}>
                            MACIZO{" "}
                            {Array.isArray(this.state.listAutorizacionesMACIZO)
                              ? `(${this.state.listAutorizacionesMACIZO.length})`
                              : ""}
                          </div>
                          {Array.isArray(this.state.listAutorizacionesMACIZO) &&
                          this.state.listAutorizacionesMACIZO.length > 0 ? (
                            this.state.listAutorizacionesMACIZO.map((row, idx) => (
                              <CardSolicitud
                                key={`MACIZO_${row.DocEntry}`}
                                row={row}
                                index={idx}
                                styles={styles}
                                data_status={data_status}
                                formatDate={formatDate}
                                abrirModalVistaPrevia={this.abrirModalVistaPrevia}
                                abrirModalAdjuntos={this.abrirModalAdjuntos}
                                get_status={this.get_status}
                                getComments={this.getComments}
                                onAutorizar={(r) => this.autorizarMACIZO(r)}
                                statusAutorizadores={this.getStatusAutorizadoresPorDocumento(row.DocEntry, "MACIZO")}
                                mostrarAutorizadores={!!this.state.autorizadoresVisibles[`MACIZO_${row.DocEntry}`]}
                                onToggleAutorizadores={this.toggleAutorizadores}
                                sociedadKey="MACIZO"
                              />
                            ))
                          ) : (
                            <div style={styles.empty}>Sin registros</div>
                          )}
                        </div>

                        {/* MOSA */}
                        <div style={styles.column}>
                          <div style={styles.columnHeader}>
                            MOSA{" "}
                            {Array.isArray(this.state.listAutorizacionesMOSA)
                              ? `(${this.state.listAutorizacionesMOSA.length})`
                              : ""}
                          </div>
                          {Array.isArray(this.state.listAutorizacionesMOSA) &&
                          this.state.listAutorizacionesMOSA.length > 0 ? (
                            this.state.listAutorizacionesMOSA.map((row, idx) => (
                              <CardSolicitud
                                key={`MOSA_${row.DocEntry}`}
                                row={row}
                                index={idx}
                                styles={styles}
                                data_status={data_status}
                                formatDate={formatDate}
                                abrirModalVistaPrevia={this.abrirModalVistaPreviaMOSA}
                                abrirModalAdjuntos={this.abrirModalAdjuntosMOSA}
                                get_status={this.get_statusMOSA}
                                getComments={this.getCommentsMOSA}
                                onAutorizar={(r) => this.autorizarMOSA(r)}
                                statusAutorizadores={this.getStatusAutorizadoresPorDocumento(row.DocEntry, "MOSA")}
                                mostrarAutorizadores={!!this.state.autorizadoresVisibles[`MOSA_${row.DocEntry}`]}
                                onToggleAutorizadores={this.toggleAutorizadores}
                                sociedadKey="MOSA"
                              />
                            ))
                          ) : (
                            <div style={styles.empty}>Sin registros</div>
                          )}
                        </div>

                        {/* TRANSFLESA */}
                        <div style={styles.column}>
                          <div style={styles.columnHeader}>
                            TRANSFLESA{" "}
                            {Array.isArray(this.state.listAutorizacionesTRANSFLESA)
                              ? `(${this.state.listAutorizacionesTRANSFLESA.length})`
                              : ""}
                          </div>
                          {Array.isArray(this.state.listAutorizacionesTRANSFLESA) &&
                          this.state.listAutorizacionesTRANSFLESA.length > 0 ? (
                            this.state.listAutorizacionesTRANSFLESA.map((row, idx) => (
                              <CardSolicitud
                                key={`TRANSFLESA_${row.DocEntry}`}
                                row={row}
                                index={idx}
                                styles={styles}
                                data_status={data_status}
                                formatDate={formatDate}
                                abrirModalVistaPrevia={this.abrirModalVistaPreviaTRANSFLESA}
                                abrirModalAdjuntos={this.abrirModalAdjuntosTRANSFLESA}
                                get_status={this.get_statusTRANSFLESA}
                                getComments={this.getCommentsTRANSFLESA}
                                onAutorizar={(r) => this.autorizarTRANSFLESA(r)}
                              />
                            ))
                          ) : (
                            <div style={styles.empty}>Sin registros</div>
                          )}
                        </div>
                      </div>
                      {/* ====== FIN LAYOUT ====== */}
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        {isLoading && <Loading />}
      </div>
    );
  }
}

export default Autorizaciones_compras;

const style = {
  message: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
